<template>
  <div id="app" >
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
  data(){
    return{
      conheight:{
          height:''
        }
    }
  },
  methods:{
    getHeight(){

    },
  },
  mounted(){

  }
}
</script>

<style>
#app{
	background:#f5f6f7;
	width: 100%;
	height: 100%;
	margin: 0;
	padding: 0;
}
</style>



// WEBPACK FOOTER //
// src/App.vue